import templateUrl from "emun.order/order-details-catalogs.htm";

export default () => ({ templateUrl });
